module.exports = __webpack_public_path__ + "e932821.woff2";